import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.SpacePort;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "SpacePort.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "SpacePort.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "";
    }
}



// WEBPACK FOOTER //
// ./src/games/SpacePortGame/scenes/IntroductionScene.ts